import {
  SECOND_DOCUMENT_TYPES,
  SecondDocumentTypes,
} from "Components/Onboarding/shared/DocumentsUpload/types";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Onboarding.Steps.Documents.Validations;

const secondDocumentSchema = (t: TFunction) =>
  z
    .object({
      documentType: z.enum(SECOND_DOCUMENT_TYPES, {
        error: t(RESOURCES.SecondDocumentTypeMissing),
      }),
      frontSide: z.instanceof(File, {
        error: t(RESOURCES.SecondForegroundMissing),
      }),
      backSide: z.instanceof(File).optional(),
    })
    .refine(
      (data) =>
        data.documentType !== SecondDocumentTypes.DrivingLicense ||
        data.backSide instanceof File,
      {
        message: t(RESOURCES.SecondBackgroundMissing),
        path: ["backSide"],
      },
    );

export const getDocumentsValidationSchema = (
  t: TFunction,
  isSecondDocumentRequired: boolean,
) =>
  z.object({
    firstDocument: z.object({
      frontSide: z.instanceof(File, { error: t(RESOURCES.ForegroundMissing) }),
      backSide: z.instanceof(File, { error: t(RESOURCES.BackgroundMissing) }),
    }),
    secondDocument: isSecondDocumentRequired
      ? secondDocumentSchema(t)
      : secondDocumentSchema(t).optional(),
  });

export type DocumentsUploadFormData = z.infer<
  ReturnType<typeof getDocumentsValidationSchema>
>;
